export const setMetaDescription = (description: string): void => {
  document
    .querySelector("meta[name='description']")
    ?.setAttribute("content", description);
};
